module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/106-panama-388737470d2dd04908eec1dacb8d35fe.svg";